<template>
  <div class="content">
    <div class="container">
      <form method="post"
            action="#"
            class="form">
        <header-logo :logo-url="logoUrl" />
        <h1 v-word:layout.login.header />
        <section class="form__section">
          <div class="form__input">
            <input v-model="email"
                   type="email"
                   v-word="{ word: 'layout.login.email.placeholder', attr: 'placeholder' }"
                   :name="wordingsEditable ? 'to-prevent-auto-fillin' : ''">
            <p v-if="usernameError"
               class="form__input__error"
               v-html="usernameError" />
          </div>
          <div class="form__input form__input--password">
            <input v-model="password"
                   :type="showPassword ? 'text' : 'password'"
                   v-word="{ word: 'layout.login.password.placeholder', attr: 'placeholder' }"
                   :autocomplete="wordingsEditable ? 'new-password' : ''"
                   :name="wordingsEditable ? 'to-prevent-auto-fillin' : ''">
            <button type="button"
                    class="form__input--password__button"
                    @click="showPassword = !showPassword"></button>
            <p v-if="passwordError"
               class="form__input__error"
               v-html="passwordError" />
          </div>
        </section>
        <section class="form__section form__section--flex">
          <div class="form__section__links">
            <a :href="!editMode && $router.resolve({ name: 'restore-password' }).href"
               v-word:layout.login.link.restorePassword />
            <a :href="!editMode && $router.resolve({ name: 'registration-1' }).href"
               v-word:layout.login.link.register />
          </div>
          <div class="form__input form__input--captcha">
            <captcha ref="captcha"
                     @verify="token => captcha = token" />
            <p v-if="captchaError"
               class="form__error">{{ captchaError }}</p>
          </div>
        </section>
        <section class="form__section">
          <p v-word:layout.login.description />
        </section>
        <section class="form__section">
          <div class="form__input form__input--submit">
            <button v-on:click="login"
                    v-word:layout.login.button.login />
          </div>
        </section>
      </form>
    </div>
    <registration-needed-modal
      ref="registration_needed_modal"
      :wordings-editable="wordingsEditable"
      :wordings="wordings"
      :wordings-meta="wordingsMeta"
      @wordingChange="onWordingChange"
      @wordingCommand="runWordingCommand"
      :wordingsOverride="wordingsOverride" />
  </div>
</template>

<script>
import config from 'config';
import * as mixins from '../mixins';
import Captcha from 'ref-captcha';
import wordings from '../utils/wordings';
import instanceConfig from './../utils/instanceConfig';
import backendConfig from './../utils/backendConfig';
import registrationNeededModal from '../modals/RegistrationNeeded';

export default {
  mixins: [mixins.wordedPage, mixins.pageWithLogo],
  props: ['store', 'showall', 'editMode'],
  components: { Captcha, registrationNeededModal },
  data() {
    return {
      email: '',
      password: '',
      captcha: '',
      invalidCaptcha: false,
      passwordError: '',
      usernameError: '',
      captchaError: '',
      bypassCaptcha: false,
      showPassword: false,
    };
  },
  created() {
    !this.editMode &&
      instanceConfig
        .get()
        .then(config => {
          this.bypassCaptcha = !!config['bypass-captcha'];
        })
        .catch(() => {});
  },
  mounted() {
    if (!this.wordingsEditable) {
      instanceConfig
        .get()
        .then(config => {
          if (config['show-registration-popup']) {
            this.$refs['registration_needed_modal'].open();
          }
        })
        .catch(() => {});
    }
  },
  methods: {
    login(evt) {
      evt.preventDefault();
      const loginData = {
        Username: this.email,
        Password: this.password,
        Captcha: this.captcha,
        Sso: this.store.brokerData,
      };

      this.usernameError = '';
      this.passwordError = '';
      this.captchaError = '';

      let invalid = false;

      if (!loginData.Username.trim()) {
        wordings().then(
          wordings =>
            (this.usernameError = wordings['validation.errors.required']),
        );
        invalid = true;
      }
      if (!loginData.Password.trim()) {
        wordings().then(
          wordings =>
            (this.passwordError = wordings['validation.errors.required']),
        );
        invalid = true;
      }
      if (!loginData.Captcha.trim() && !this.bypassCaptcha) {
        wordings().then(
          wordings =>
            (this.captchaError = wordings['validation.errors.required']),
        );
        invalid = true;
      }

      if (invalid) {
        this.$refs.captcha.reset();
        return;
      }

      this.$emit('loading');
      backendConfig.get().then(({backendUrl}) => {
        this.$http
          .post(backendUrl + config.backend.feeds.login, loginData)
          .then(function(resp) {
            if (this.$route.params && this.$route.params.back) {
              this.$emit('loaded');
              this.$router.push({ name: this.$route.params.back });
            } else {
              const redirectUrl = resp.body.RedirectUrl;
              window.location.href = resp.body.RedirectUrl;
            }
          })
          .catch(function(resp) {
            this.handleErrors(resp.data.errors);
            this.$refs.captcha.reset();
            this.$emit('loaded');

            if (resp.status >= 500) {
              this.flash(this.wordings['flashes.generalError'], 'error');
            }
          });
        });
    },
    handleErrors(errors) {
      if (typeof errors.login !== 'undefined') {
        this.flash(this.wordings['layout.login.invalidCredentials'], 'error');
      }

      if (typeof errors.captcha !== 'undefined') {
        wordings().then(
          wordings =>
            (this.captchaError = wordings['validation.errors.required']),
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form__input__error {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue